(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const announcementClose = document.getElementById('wf-announcement-close');
  const announcementBar   = document.getElementById('wf-announcement');

  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      try { sessionStorage.setItem('wf-announcement-closed', '1'); } catch (e) {}
    });
    try {
      if (sessionStorage.getItem('wf-announcement-closed') === '1') {
        announcementBar.style.display = 'none';
      }
    } catch (e) {}
  }

  const navToggle  = document.getElementById('wf-nav-toggle');
  const drawer     = document.getElementById('wf-mobile-drawer');
  const overlay    = document.getElementById('wf-nav-overlay');
  const drawerClose = document.getElementById('wf-drawer-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); }
    if (navToggle) navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const firstLink = drawer.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); }
    if (navToggle) { navToggle.setAttribute('aria-expanded', 'false'); navToggle.focus(); }
    document.body.style.overflow = '';
  }

  if (navToggle)   navToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay)     overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  const expandableBtns = document.querySelectorAll('.site-header__drawer-link--expandable');
  expandableBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('aria-controls');
      const sub = targetId ? document.getElementById(targetId) : null;
      if (!sub) return;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      sub.classList.toggle('is-open', !isOpen);
      sub.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
  });

  const mobileSearchToggle = document.getElementById('wf-mobile-search-toggle');
  const mobileSearchBar    = document.getElementById('wf-mobile-search');
  const mobileSearchInput  = document.getElementById('wf-mobile-search-input');

  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener('click', () => {
      const isOpen = mobileSearchBar.classList.contains('is-open');
      mobileSearchBar.classList.toggle('is-open', !isOpen);
      mobileSearchBar.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      if (!isOpen && mobileSearchInput) mobileSearchInput.focus();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
